<ng-container *transloco="let t; read: 'auth'">
 <h3>{{ t('accessDeniedTitle') }}</h3>
 <p>{{ t('accessDeniedMessage') }}</p>
 <a [routerLink]="['/']">
   {{ t('backToHome') }}
 </a>
</ng-container>
